import { observable, computed } from 'mobx'
import { unixEpoch } from '@/utils/date-util'
import { TeamMember } from './TeamMember'
import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { once } from 'lodash-es'
import { generateAvatarFallback } from '@/utils/image-util'
import { Workspace } from '@/features/iam/workspaces/Workspace'

export interface TeamAddress {
  streetAddress?: string
  zipCode?: string
  city?: string
  state?: string
  country?: string
}

export type TeamProps = ModelProps<Team>

export class Team extends Model<Team> {
  id = Id.none
  @observable accessor name = ''
  @observable accessor slug = ''
  @observable accessor picture = ''
  @observable accessor inactive = false
  @observable accessor dateCreated: Date = unixEpoch()
  @observable accessor dateModified: Date = unixEpoch()
  @observable accessor owner = TeamMember.none
  @observable accessor teamPurpose = ''
  @observable accessor address: TeamAddress = {}
  @observable accessor workspace = Workspace.none

  static get none(): Team {
    return lazyNone()
  }

  @computed
  get avatar() {
    return this.picture || generateAvatarFallback(this.name)
  }
}

const lazyNone = once(() =>
  new Team().set({
    name: 'Team',
    slug: 'team',
  }),
)
